import React, {useMemo} from 'react'
import moment from 'moment'
import {fill} from '../../utils/ApColor'
const EventBar = ({data, onClick, selectedDate, dayCount, style, ...root}) => {
  const {border_color, background_color, variants = [], overdue_height} = useMemo(() => {
    let selDateStart = selectedDate.clone().startOf('day')
    let selDateEnd = selDateStart
      .clone()
      .add(dayCount - 1, 'days')
      .endOf('day')

    const item = data.event
    /**
     *  Color of event based upon calendar view selected (Default)
     */
    let border_color = item.bgColor || '#fff'
    let background_color = `${item.bgColor}22` || '#fff'
    let overdue_height = 0
    let variants = []

    let realEnd = moment(item.action_return_date || item.end)

    // check overdue
    if (!!item.action_return_date && item.end.valueOf() < item.action_return_date.valueOf()) {
      let _diff = item.action_return_date.valueOf() - item.end.valueOf()
      let _diff2 = item.action_return_date.valueOf() - item.start.valueOf()
      let _perc = (_diff / _diff2) * 100
      overdue_height = Math.min(_perc, 100)

      // variants
      variants.push('event-bar--overdue')
    }

    if (item.type === 'SystemReservationAction') {
      /**
       *  Dotted outline for awaiting manager approval
       */
      if (item.status === 'requested' && item.state === 'pending') {
        variants.push('event-bar--dotted')
        border_color = item.bgColor
        background_color = item.bgColor + '22'
        /**
       * Solid outline for manager approved events
          Or events not requiring approval
      */
      } else if (item.status === 'upcoming') {
        variants.push('event-bar--solid')
        border_color = item.bgColor
        background_color = item.bgColor + '22'
      }

      // fix end date if fulfilled overdue
      if (item.state === 'overdue' && item.status === 'fulfilled') {
        realEnd = moment()
      }

      // check overdue
      if (item.end.valueOf() < realEnd.valueOf()) {
        let _diff = realEnd.valueOf() - item.end.valueOf()
        let _diff2 = realEnd.valueOf() - item.start.valueOf()
        let _perc = (_diff / _diff2) * 100
        overdue_height = Math.min(_perc, 100)

        // variants
        variants.push('event-bar--overdue')
      }
    }

    // check faded left
    if (
      selDateStart >
      item.start
        .clone()
        .startOf('day')
        .valueOf()
    ) {
      variants.push('event-bar--faded-left')
    }

    // check faded right
    if (
      selDateEnd <
      realEnd
        .clone()
        .startOf('day')
        .valueOf()
    ) {
      variants.push('event-bar--faded-right')
    }

    return {variants, border_color, background_color, overdue_height}
  }, [data, selectedDate, dayCount])

  return (
    <div
      {...root}
      className={`event-bar ${variants.join(' ')}`}
      onClick={e => onClick(data.event)}
      style={{
        ...style,
        borderColor: border_color,
        '--bg-color': fill(background_color, 0.3),
      }}
      title={data.title}
    >
      <span>{data.title}</span>
    </div>
  )
}

export default EventBar
